/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Storyblok_Breadcrumb } from '../models/Storyblok_Breadcrumb';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoryblokService {
    /**
     * Storyblok breadcrumbs
     * @returns Storyblok_Breadcrumb Success
     * @throws ApiError
     */
    public static getApiVStoryblokBreadcrumbs({
        identifier,
        apiVersion = 1,
    }: {
        /**
         * The full slug, ID or UUID of the entry.
         */
        identifier: (string | number),
        apiVersion?: number,
    }): CancelablePromise<Array<Storyblok_Breadcrumb>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/breadcrumbs/{identifier}',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
}
